import React, { FC } from 'react';
import { Stack } from '@mui/material';
import Text from '@ingka/text';
import Button from '@ingka/button';
import useTranslation from '../../hooks/useTranslation';

const GuestAccessNotification: FC<{ countryAdminListUrl: string }> = () => {
  const t = useTranslation();

  return (
    <Stack
      spacing={2}
      alignItems="flex-start"
      style={{
        maxWidth: '700px',
        padding: '52px 0 0 24px',
      }}
    >
      <Text tagName="h1" textStyle="Heading.L">
        {t('guestAccessNotification.title')}
      </Text>
      <Text tagName="p" textStyle="Body.M">
        {t('guestAccessNotification.description')}
      </Text>
      <Text tagName="p" textStyle="Body.M">
        <strong>{t('guestAccessNotification.whatToDoTitle')}</strong>{' '}
        {t('guestAccessNotification.whatToDoDescription')}
      </Text>
      <Button
        href={
          'https://iweof.sharepoint.com/:x:/t/o365g_gexprojectportfoliomeetings_issemal-ProjectPortfolioManagement/EaeJ9kzU61BAq2bfWOy1xxABv2jgAeuPAgtcvNaeUHuIMA?e=KOKcsy'
        }
        target="_blank"
        rel="noopener noreferrer"
        style={{
          borderRadius: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <span style={{ marginRight: '8px' }}>&#x2197;</span>
        {t('guestAccessNotification.linkText')}
      </Button>
    </Stack>
  );
};

export default GuestAccessNotification;
